<ng-container>
  <div class="wrapper__form">
    <div
      class="d-flex flex-xl-row align-items-center mb-4 justify-content-between">
      <h2 class="wrapper__form__title h4-tipografia-govco mb-0">
        {{ proconText['tramite-sic-procon']['pruebas'] }}
      </h2>
    </div>

    <div class="carga-archivo-govco">
      <span class="alert-carga-archivo-govco">
        {{ proconText['tramite-sic-procon']['atencion'] }}
      </span>
    </div>
    <h4 class="wrapper__form__title h3-tipografia-govco mb-0" *ngIf="archivosFiltrados(1).length > 0">
      {{ proconText['tramite-sic-procon']['poder-judicial'] }}
    </h4>

    <!-- <app-cargue-archivos-tramite
      [archivosPreCargados]="archivosFiltrados(1)"
      [idTipoTramite]="Constants.SIC_PROCON"
      [idTramite]="idTramite"
      [btnEnviar]="false"
      [enviarEntidad]="false"
      [enviar]="enviar"
      (guardo)="subir($event, 1)"
      [nombreCortoTramite]="nombreCortoLimpioTramite"
      [codigoPretencion]="reglaPaso1"
      [reglaRequerido]="JSON.stringify(reglaPaso1)"
      [reglaRequeridoEstricto]="true"
      (archivosCargados)="getArchivosByPaso($event, 1)"/>
    <div class="mt-3 text-muted small d-flex align-items-center" *ngIf="archivosFiltrados(1).length > 0">
      <i class="bi bi-info-circle me-2"></i>
      {{ 'copia_envio.peso_actual' | translate:{ peso: pesoArchivosPaso1 } }}
    </div> -->
    <div class="container-detail-carga-archivo-govco">
      <div class="attached-files-carga-archivo-govco" *ngIf="archivosFiltrados(1).length > 0">
        <div
          class="attached-file-carga-de-archivo"
          tabindex="0"
          *ngFor="let file of archivosFiltrados(1); let i = index">
          <div class="icon-text-carga-de-archivo">
            <span class="govco-svg">
              <img
                src="assets/img/file-alt-white.svg"
                alt="Se cargo un documento"
                class="style-icos-upload-files" />
            </span>
            <div class="container-text-name-carga-de-archivo">
              <span class="text-name-carga-de-archivo-govco">{{
                file.nombreArchivo
              }}</span>
              <br>
              <span>{{ bytesToKb(+file.tamano) }} Kb</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br>
    <h4 class="wrapper__form__title h3-tipografia-govco mb-0" *ngIf="archivosFiltrados(3).length > 0">
      {{ proconText['tramite-sic-procon']['reclamo-directo'] }}
    </h4>
    <!-- <app-cargue-archivos-tramite
      [archivosPreCargados]="archivosFiltrados(3)"
      [idTipoTramite]="Constants.SIC_PROCON"
      [idTramite]="idTramite"
      [btnEnviar]="false"
      [enviarEntidad]="false"
      [enviar]="enviar"
      (guardo)="subir($event, 3)"
      [nombreCortoTramite]="nombreCortoLimpioTramite"
      [codigoPretencion]="reglaPaso3"
      [reglaRequerido]="JSON.stringify(reglaPaso3)"
      [reglaRequeridoEstricto]="true"
      (archivosCargados)="getArchivosByPaso($event, 3)"/>
    <div class="mt-3 text-muted small d-flex align-items-center" *ngIf="archivosFiltrados(3).length > 0">
        <i class="bi bi-info-circle me-2"></i>
        {{ 'copia_envio.peso_actual' | translate:{ peso: pesoArchivosPaso3 } }}
    </div> -->
    <div class="container-detail-carga-archivo-govco">
      <div class="attached-files-carga-archivo-govco" *ngIf="archivosFiltrados(3).length > 0">
        <div
          class="attached-file-carga-de-archivo"
          tabindex="0"
          *ngFor="let file of archivosFiltrados(3); let i = index">
          <div class="icon-text-carga-de-archivo">
            <span class="govco-svg">
              <img
                src="assets/img/file-alt-white.svg"
                alt="Se cargo un documento"
                class="style-icos-upload-files" />
            </span>
            <div class="container-text-name-carga-de-archivo">
              <span class="text-name-carga-de-archivo-govco">{{
                file.nombreArchivo
              }}</span>
              <br>
              <span>{{ bytesToKb(+file.tamano) }} Kb</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br>
    <div *ngIf="tramiteSic?.tipoProteccion?.tipoProteccion?.codigo === 'PR_PC' ||
    tramiteSic?.tipoProteccion?.tipoProteccion?.codigo === 'PR_PIE'">
        <h4 class="wrapper__form__title h3-tipografia-govco mb-0" *ngIf="archivosFiltrados(4).length > 0">
          {{ proconText['tramite-sic-procon']['proteccion-requiere'] }}
        </h4>
        <!-- <app-cargue-archivos-tramite
          [archivosPreCargados]="archivosFiltrados(4)"
          [idTipoTramite]="Constants.SIC_PROCON"
          [idTramite]="idTramite"
          [btnEnviar]="false"
          [enviarEntidad]="false"
          [enviar]="enviar"
          (guardo)="subir($event, 4)"
          [nombreCortoTramite]="nombreCortoLimpioTramite"
          [codigoPretencion]="reglaPaso4"
          [reglaRequerido]="JSON.stringify(reglaPaso4)"
          [reglaRequeridoEstricto]="true"
          (archivosCargados)="getArchivosByPaso($event, 4)"/>
        <div class="mt-3 text-muted small d-flex align-items-center" *ngIf="archivosFiltrados(4).length > 0">
            <i class="bi bi-info-circle me-2"></i>
            {{ 'copia_envio.peso_actual' | translate:{ peso: pesoArchivosPaso4 } }}
        </div> -->
      <div class="container-detail-carga-archivo-govco">
        <div class="attached-files-carga-archivo-govco">
          <div
            class="attached-file-carga-de-archivo"
            tabindex="0"
            *ngFor="let file of archivosFiltrados(4); let i = index">
            <div class="icon-text-carga-de-archivo">
              <span class="govco-svg">
                <img
                  src="assets/img/file-alt-white.svg"
                  alt="Se cargo un documento"
                  class="style-icos-upload-files" />
              </span>
              <div class="container-text-name-carga-de-archivo">
                <span class="text-name-carga-de-archivo-govco">{{
                  file.nombreArchivo
                }}</span>
                <br>
                <span>{{ bytesToKb(+file.tamano) }} Kb</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br>
    <h4 class="wrapper__form__title h3-tipografia-govco mb-0">
      {{ proconText['tramite-sic-procon']['otras-pruebas'] }}
    </h4>
    <app-cargue-archivos-tramite
      *ngIf="mostrarArchivos"
      [archivosPreCargados]="archivosFiltrados(7)"
      [idTipoTramite]="2"
      [idTramite]="idTramite"
      [btnEnviar]="false"
      [enviarEntidad]="false"
      [enviar]="enviar"
      (guardo)="subir($event, 7)"
      [nombreCortoTramite]="nombreCortoLimpioTramite"
      [codigoPretencion]="jsonRegla"
      [reglaRequerido]="JSON.stringify(jsonRegla)"
      [reglaRequeridoEstricto]="true"
      (archivosCargados)="getArchivosByPaso($event, 7)"/>
    <div class="mt-3 text-muted small d-flex align-items-center" *ngIf="archivosFiltrados(7).length > 0">
      <i class="bi bi-info-circle me-2"></i>
      {{ 'copia_envio.peso_actual' | translate:{ peso: pesoArchivosPaso7 } }}
    </div>
  </div>

  <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
    <div class="d-flex flex-column flex-md-row gap-2">
      <button
        type="submit"
        class="btn-govco fill-before-btn-govco w-auto"
        (click)="anterior()"
        onClick="nextItemAdvanceLineIHorizonalBack(event)"
        [attr.aria-label]="proconText['botones-envio']['atras']">
        {{ proconText['botones-envio']['atras'] }}
      </button>


      <button
        type="button"
        class="btn-govco fill-btn-govco w-auto"
        (click)="siguiente($event, true)"
        [attr.aria-label]="proconText['botones-envio']['guardar-sin-enviar']">
        {{ proconText['botones-envio']['guardar-sin-enviar'] }}
      </button>

      <button
        type="submit"
        class="btn-govco fill-next-btn-govco w-auto"
        (click)="siguiente($event, false)"
        [attr.aria-label]="proconText['siguiente']">
        {{ proconText['siguiente'] }}
      </button>
    </div>
  </div>
</ng-container>
